<template>
  <div class="signup-user-form">
    <Header propsTitle="회원가입" @clickBack="$emit('clickBack')" />
    <div class="container">
      <div id="userDetail" class="page-inner">
        <!-- <Stepper step="3" /> -->

        <v-form ref="form">
          <!-- 회원유형 -->
          <UserTypeForm :userData="userData" @clickUserType="onClickUserType" />

          <!-- 회원정보: 유형 선택 후 표시 -->
          <CommonForm v-if="userData.userType === 'DOCTOR' || userData.userType === 'PHARMACIST'" ref="refCommonForm" :userData="userData" />

          <!-- 약관동의 -->
          <WSSignUpAgree v-if="userData.userType === 'DOCTOR' || userData.userType === 'PHARMACIST'" :userData="userData" />

          <!-- 버튼 처리 -->
          <div class="bottom-btn mt-10" v-if="userData.userType === 'DOCTOR' || userData.userType === 'PHARMACIST'">
            <v-btn class='btn-text-white' color="mainColorDark" x-large depressed block @click="clickSave">
              가입완료
            </v-btn>
          </div>
        </v-form>
      </div>
    </div>
    <ConfirmDialog ref="refConfirmDialog" @clickOk="clickPopupConfirm" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Header from "../../commonComp/WS-Header.vue";
import UserTypeForm from "./userForm/comp/UserTypeForm.vue";
import CommonForm from "./CommonForm.vue";
import WSSignUpAgree from "./WS-SignUpAgree.vue";
const rulesService = require("@/utils/rules.js");
import ConfirmDialog from "@/_zplabZPT/commonComp/dialog/ConfirmDialog.vue";

export default {
  components: {
    Header,
    UserTypeForm,
    CommonForm,
    WSSignUpAgree,
    ConfirmDialog,
  },
  props: {
    userData: {
      type: Object,
    },
  },
  data() {
    return {
      emailIdRules: rulesService.emailIdRules(),
    };
  },
  computed: {
    ...mapGetters(["isDev", "isAuthorized"]),
  },
  methods: {
    onClickUserType(userType) {
      this.userData.userType = userType
    },
    clickSave() {
      // 필수체크
      const $h = this.$helper;
      const DT = this.userData;
      const RF = this.$refs;
      const objRF = RF.refCommonForm.$refs;

      // 의사 - 진료과 기타인 경우 수동 입력한 진료과로 설정
      if(DT.userType == 'DOCTOR' && DT.majors == '기타'){
        this.userData.majors = this.userData.majorsEtc
      }

      if (!RF.form.validate()) {
        console.log("RF.form.validate() 에러");
        return;
      }

      this.$refs.refConfirmDialog.open("회원가입하시겠습니까?");
    },
    clickPopupConfirm() {
      this.$emit("prepareSignUp");
    },

    scrollTop() {
      const scrollTarget = document.getElementById("userDetail");
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style lang="scss">
.signup-user-form {
  .section-inner {
    max-width: 800px;
    width: 65vw;
  }

  .section-header {
    padding: 0 1rem 2.5rem;
    text-align: center;

    .input-guide {
      margin-top: 1.5rem;
    }
  }

  .row {
    margin: 0;

    .col {
      padding: 0;

      .v-btn {
        min-width: calc(100% - 10px);
        padding: 0;
        margin-left: 10px;
      }
    }
  }

  .bottom-wrap {
    margin: 5rem 0 1rem;

    .v-btn--block {
      display: inline-flex;
      min-width: initial !important;
      width: calc(50% - 6px);

      &:last-child {
        margin-left: 12px;
      }
    }
  }
}

@media (max-width: 768px) {
  div.user-profile {
    padding: 0;

    .row-cell {
      .col-9 {
        flex: 0 0 60%;
        max-width: 60%;
      }

      .col-3 {
        flex: 0 0 40%;
        max-width: 40%;
      }
    }

    .row-code {
      flex-direction: column;
      margin-bottom: 24px;

      .col {
        max-width: 100%;

        .v-btn {
          min-width: 100%;
          margin-left: 0;
        }
      }
    }

    .bottom-wrap {
      .v-btn--block {
        display: flex;
        min-width: 100% !important;

        &:last-child {
          margin-left: 0;
          margin-top: 12px;
        }
      }
    }
  }
}
</style>
